import React, { memo, useEffect, useMemo, useState } from "react";
import { closeModal, openModal } from "../../store/actions/modalAction";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Chip,
  CircularProgress,
  IconButton,
  ListItem,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  fetchStockInOutApi,
  GenerateInventoryQrCodeApi,
} from "../../apis/inventoryLogs.api";
import { Download, Edit, Info, Visibility } from "@mui/icons-material";
import { callApiAction } from "../../store/actions/commonAction";
import moment from "moment";
import { findObjectKeyByValue } from "../../utils/main";
import {
  LOG_TYPE,
  MATERIAL_TYPE,
  SNACK_BAR_VARIETNS,
} from "../../utils/constants";
import UpdateStockController from "./UpdateStockController";
import StockInOutListUi from "./StockInOutListUi";
import { useParams } from "react-router-dom";
import { saveAs } from "file-saver";
import { callSnackBar } from "../../store/actions/snackbarAction";
import RejectedQuantityController from "./RejectedQuantityController";
import CommonActionComponent from "../../components/CommonActionComponent";
import MODULES from "../../utils/module.constant";
import EditLocationIcon from "@mui/icons-material/EditLocation";
import { CenteredBox } from "../../components/layouts/OneViewBox";
import { StyledSearchBar } from "../../components/inputs/SearchBar";
import AsyncDropDown from "../../components/inputs/AsyncDropDown";
import { fetchlocationMasterApi } from "../../apis/locationMaster.api";
import PaddingBoxInDesktop from "../../components/layouts/PaddingBoxDesktop";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import { UpdateStockLocationApi } from "../../apis/stockinout.api";

const ActionComponent = memo(({ params, setParams, Type }) => {
  const dispatch = useDispatch();

  const [downloadLoading, setDownloadLoading] = useState(false);

  const handleQrImageDownload = async (params) => {
    setDownloadLoading(true);
    try {
      const response = await GenerateInventoryQrCodeApi({
        _id: params?.location?._id,
      });
      const qrImageBlob = response.data;
      const sanitizeFilename = (name) =>
        name?.replace(/[^a-z0-9_\-]/gi, "_") || "qr_code";

      const filename = `${sanitizeFilename(params?.location?.name)}.png`;

      saveAs(qrImageBlob, filename);
    } catch (downloadError) {
      dispatch(callSnackBar("Cannot Download QR", SNACK_BAR_VARIETNS.error));
    } finally {
      setDownloadLoading(false);
    }
  };

  return (
    <Box sx={{ width: "100%", alignItems: "flex-start", display: "flex" }}>
      <Box
        onClick={() => params?.location?.name && handleQrImageDownload(params)}
        disabled={downloadLoading}
      >
        {downloadLoading ? (
          <CircularProgress size={24} />
        ) : (
          <Tooltip
            title={
              params?.location?.name
                ? "Download Location Qr Code"
                : "No Location available"
            }
          >
            <Typography
              sx={{
                display: "flex",
                textDecoration: params?.location?.name ? "underline" : "none",
                cursor: params?.location?.name ? "pointer" : "default",
              }}
            >
              {params?.location?.name || "NA"}
            </Typography>
          </Tooltip>
        )}
      </Box>
    </Box>
  );
});

const StockInOutListController = ({ Type }) => {
  const dispatch = useDispatch();
  const params = useParams();

  const id = "stockInOut";
  const [list, setList] = useState({});
  const [loading, setLoading] = useState(false);

  const onCreateBtnClick = () => {
    dispatch(
      openModal(
        <UpdateStockController
          id={params._id}
          Type={Type}
          callBack={() => {
            fetchList();
          }}
        />,
        "sm",
        false,
        id,
      ),
    );
  };

  const [filters, setFilters] = useState({
    pageNo: 1,
    pageSize: 10,
    search: "",
    searchable: ["name"],
    sort: "",
    sortDirection: -1,
  });

  const fetchList = () => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await fetchStockInOutApi({ ...filters, Type }),
        (response) => {
          setList(response);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        },
      ),
    );
  };

  const LocationUi = ({ params }) => {
    const [loading1, setLoading1] = useState(false);
    const [fields, setFields] = useState({
      location: params?.location?._id || null,
      locationName: params?.location?.name || "",
      err: "",
    });

    const onSubmit = async (e) => {
      e.preventDefault();
      if (!fields.location) {
        setFields({ ...fields, err: "Please select location" });
        return;
      }

      setLoading1(true);
      dispatch(
        callApiAction(
          async () =>
            await UpdateStockLocationApi({
              id: params._id,
              location: fields.location,
            }),
          async (response) => {
            setLoading1(false);
            dispatch(
              callSnackBar(
                "Updated Location Successfully",
                SNACK_BAR_VARIETNS.suceess,
              ),
            );
            dispatch(closeModal("editLocation"));
            fetchList();
          },
          (err) => {
            setLoading1(false);
            setFields({ ...fields, err });
          },
        ),
      );
    };

    return (
      <CustomDialog
        id={"editLocation"}
        loading={loading1}
        err={fields?.err}
        onSubmit={(e) => onSubmit(e)}
        title={
          (params?.location?.name &&
            `Edit Location For This ${params?.materialDetails?.name}`) ||
          `Add Location For This ${params?.materialDetails?.name}`
        }
        closeText={"Close"}
        confirmText={"Submit"}
      >
        {loading1 ? (
          <CenteredBox>
            <CircularProgress />
          </CenteredBox>
        ) : (
          <>
            <PaddingBoxInDesktop
              mt={3}
              sx={{ display: "flex", flex: 1, justifyContent: "flex-end" }}
            >
              <AsyncDropDown
                lazyFun={async (para) =>
                  await fetchlocationMasterApi({ ...para, allStatus: true })
                }
                OptionComponent={({ option, ...rest }) => {
                  return <ListItem {...rest}>{option.name}</ListItem>;
                }}
                Value={{
                  _id: fields.location || "",
                  name: fields.locationName || "",
                }}
                onChange={async (changedVal) => {
                  setFields({
                    ...fields,
                    location: changedVal ? changedVal._id : null,
                    locationName: changedVal ? changedVal.name : "",
                  });
                }}
                titleKey={"name"}
                valueKey={"_id"}
                InputComponent={(params) => (
                  <StyledSearchBar
                    placeholder={"Location Master*"}
                    {...params}
                    margin="none"
                  />
                )}
              />
            </PaddingBoxInDesktop>
          </>
        )}
      </CustomDialog>
    );
  };

  const OnEditLocationClick = (params, setParams) => {
    dispatch(
      openModal(<LocationUi params={params} />, "sm", false, "editLocation"),
    );
  };

  const columns = useMemo(
    () => [
      {
        id: 1,
        fieldName: "",
        label: "Date",
        align: "left",
        sort: true,
        renderValue: (params, setParams) =>
          moment(params?.date).format("DD/MM/YYYY") || "NA",
      },

      {
        id: 2,
        fieldName: "",
        label: "Material Type",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => (
          <Typography color={"#255766"} variant="body1">
            {findObjectKeyByValue(params?.materialType, MATERIAL_TYPE)}
          </Typography>
        ),
      },

      {
        id: 3,
        fieldName: "",
        label: "Material Name",
        align: "left",
        sort: true,
        renderValue: (params, setParams) =>
          params?.materialDetails?.name || "NA",
      },

      {
        id: 4,
        fieldName: "",
        label: "Batch Number",
        align: "left",
        sort: true,
        renderValue: (params, setParams) =>
          params?.batchNumbers?.map((item, index) => (
            <Chip
              sx={{ mr: 1 }}
              key={index}
              label={`${item?.batchNumber}`}
              color="info"
              variant="outlined"
            />
          )),
      },

      {
        id: 5,
        fieldName: "",
        label: "Quantity",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => params?.quantity || "NA",
      },
      {
        id: 6,
        fieldName: "",
        label: "Amount",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => params?.amount || "NA",
      },

      {
        id: 10,
        fieldName: "",
        label: "GRN",
        align: "left",
        sort: true,
        renderValue: (params, setParams) =>
          params?.grnDetails?.grn_number || "NA",
      },

      // {
      //   id: 6,
      //   fieldName: "",
      //   label: "Vendor",
      //   align: "left",
      //   sort: true,
      //   hide: Type === LOG_TYPE.Out,
      //   renderValue: (params, setParams) => params?.vendor?.name || "NA",
      // },
      {
        id: 7,
        fieldName: "",
        label: "Category",
        align: "left",
        sort: true,
        hide: Type === LOG_TYPE.In,
        renderValue: (params, setParams) => params?.category?.name || "NA",
      },
      {
        id: 8,
        fieldName: "",
        label: "Invoice Number",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => (
          <span
            dangerouslySetInnerHTML={{
              __html: params?.invoiceNumber || "NA",
            }}
          />
        ),
      },
      {
        id: 9,
        fieldName: "",
        label: "Location",
        align: "left",
        sort: true,
        // hide: Type === LOG_TYPE.In,
        renderValue: (params, setParams) => (
          <ActionComponent params={params} setParams={setParams} Type={Type} />
        ),
      },
      {
        id: 10,
        fieldName: "",
        label: "Action",
        align: "right",
        renderValue: (params, setParams) => (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
              flexDirection: "row",
              cursor: "pointer",
            }}
          >
            {Type === LOG_TYPE.In && (
              <Box onClick={() => OnEditLocationClick(params, setParams)}>
                <Tooltip
                  title={
                    (params?.location?.name &&
                      `Edit Location For This ${params?.materialDetails?.name}`) ||
                    `Add Location For This ${params?.materialDetails?.name}`
                  }
                >
                  <EditLocationIcon sx={{ mr: 1 }} />
                </Tooltip>
              </Box>
            )}
            <CommonActionComponent
              ViewComponent={RejectedQuantityController}
              modalkeyView={
                Type === LOG_TYPE.Out && params.isReturned && "RejectedQuantity"
              }
              modalkey={"RejectedQuantity"}
              EditComponent={!params.isReturned && RejectedQuantityController}
              params={params}
              setParams={setParams}
              ModuleMatch={
                Type === LOG_TYPE.In ? MODULES.STOCK_IN : MODULES.STOCK_OUT
              }
              isDownload={true}
              isSize={"md"}
              callBack={() => fetchList()}
            />
          </Box>
        ),
      },
    ],
    [dispatch, Type],
  );

  useEffect(() => {
    fetchList();
  }, [filters, Type]);

  return (
    <StockInOutListUi
      onCreateBtnClick={onCreateBtnClick}
      list={list}
      setList={setList}
      loading={loading}
      filters={filters}
      columns={columns}
      setFilters={setFilters}
      Type={Type}
    />
  );
};

export default StockInOutListController;
